module.exports = ".card {\n  background-color: #f6f8f9;\n  border-color: #f6f8f9; }\n  .card.success {\n    background-color: #e7f7ff; }\n  .moderation-icon.small {\n  width: 18px;\n  height: 18px; }\n  h3 {\n  font-size: 24px;\n  font-weight: 900; }\n  @media (max-width: 767px) {\n    h3 {\n      font-size: 18px; } }\n  h3.small {\n    font-size: 16px;\n    font-weight: normal; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/user-moderation-status/user-moderation-status.component.scss
// module id = ./src/app/accounts/user-moderation-status/user-moderation-status.component.scss
// module chunks = main